// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/module-planning-class-schema',
  type: 'object',
  required: ['id', 'primaryLeadLecturerId', 'startYear'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    name: {
      type: 'string',
      nullable: true,
    },
    primaryLeadLecturerId: {
      type: 'integer',
    },
    startYear: {
      type: 'integer',
    },
    isPrototype: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
